import { Button } from '@mui/material'

// Imports custom
import { FileManagerList } from 'common'
import { TooltipInformation } from 'common'
import { Edit3 } from 'react-feather'

export const VehicleStatusTable = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const {FormExpenses:{formState}} = Forms

    const {fetchAllStatus:{vehicleStatus}} = FetchData
        
    // const {formOpeningMode } = globalStates 

    const {handleClickDeleteVehicleStatus, handleClickEditStatus} = Actions

    const cellRendererTooltip = (params) => {
        //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
        const {idestado, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
        return(
            <>
                <TooltipInformation 
                    idregistro={idestado}
                    usuario_creo={usuario_creo}
                    fecha_creo={fecha_creo}
                    usuario_modifico={usuario_modifico}
                    fecha_modifico={fecha_modifico}
                />
            </>
            
        )
    }

    const cellRendererOptions = (params) => {

        const { idestado } = params.data
        

          return (
            <>
                <Button 
                    startIcon = { <Edit3/>}
                    variant='contained'
                    size='small' 
                    color='success'
                    sx={{ marginRight: '8px' }}
                    onClick={() => handleClickEditStatus(idestado)} 
                    > 
                    Editar 
                </Button>
                <Button 
                    variant='contained' 
                    size='small' 
                    onClick={() => handleClickDeleteVehicleStatus(idestado)}  
                    color='error' 
                    style={ { marginRight: '0.4vh' } }  > 
                    <i className="fa-solid fa-trash" style={{ marginRight: '8px' }}></i> Eliminar
                </Button>
            </>
          )

        
        
    }

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "INFO", 
            minWidth: 120,
            maxWidth: 120,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererTooltip
        },
        { field: "fecha", headerName: "FECHA", maxWidth: 110, filter: true },
        { field: "disponibilidad", headerName: "ESTADO", maxWidth: 150, filter: true },
        { field: "ubicacion", headerName: "UBICACION", maxWidth: 150, filter: true },
        { field: "descripcion", headerName: "DESCRIPCION", minWidth: 750, filter: true },
        {
            headerName: "OPCIONES",minWidth: 280,
            cellRenderer: cellRendererOptions
        },
    ]

    
    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <FileManagerList
                rowConfig={vehicleStatus}
                // rowConfig={[]}
                columnConfig={columnConfig}
            />
        </div>
    )
    
}